import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./AdvertisingBanner.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";

const slides = [
  {
    title: "Premium Properties in Gurugram",
    desc: "Exclusive deals on DLF Floors & Luxury Apartments",
    button: "Explore Now",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
  },
  {
    title: "Commercial Spaces for Lease",
    desc: "Prime locations in Cyber City & Udyog Vihar",
    button: "View Listings",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
  },
  {
    title: "South Delhi Luxury Homes",
    desc: "Vasant Vihar, Anand Lok & More",
    button: "Contact Us",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c",
  },
];

const AdvertisingBanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const res = await HomeService.getBanner();
      console.log("Banner", res);
      if (res?.status) {
        setBanners(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    // fade: true, //  This gives replace effect
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <section className="banner-section-ad ">
      <div className="banner-container-ad">
        {loading && (
          <div
            style={{
              // display: "flex",
              // justifyContent: "center",
              // alignItems: "center",
              textAlign: "center",
              width: "100%",
            }}
          >
            <div
              className="property_grid_div text-center p-4"
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                textAlign: "center",
                width: "100%",
              }}
            >
              <div
                className="spinner-border text-primary"
                style={{ marginLeft: "70%", marginTop: "15%" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              {/* <p className="mt-2">Loading properties...</p> */}
            </div>
          </div>
        )}
        <Slider {...settings}>
          {banners.map((slide, index) => (
            <div key={index}>
              <div className="slide-ad">
                {/* <div className="overlay-ad" /> */}

                <img src={slide.image} alt="" />

                <div className="content-ad">
                  <span className="tag-ad">Featured</span>

                  <h2>{slide.title}</h2>
                  <p>{slide.description}</p>

                  {/* <button className="btn-ad">{slide.button} →</button> */}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default AdvertisingBanner;
